module.exports = __webpack_public_path__ + "img/MN.9046dfeb.svg";